<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template #footer>
      <div class="modal-btn">
        <a-button
          type="primary"
          @click="handleCancel"
        >确定</a-button>
      </div>
    </template>
    <p>{{ toastMessage }}</p>
  </a-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ContractModal',
  props: {
    title: {
      type: String,
      default: '续约提示',
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    toastMessage(val) {
      if (val) {
        this.visible = true;
      }
    },
  },
  computed: {
    ...mapState(['contractInfo']),
    toastMessage() {
      return this.content || this.contractInfo.toastMessage;
    },
  },
  methods: {
    ...mapMutations(['updateContractInfo']),
    // 关闭弹窗
    handleCancel() {
      this.visible = false;
      this.updateContractInfo({
        toastMessage: '',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-btn {
  text-align: center;
}
</style>
